import {Component, OnInit, Input} from '@angular/core';
import {EventsService} from "../../../events.service";
import {AppSettings} from '../../../../app.settings';

@Component({
  selector: 'app-leaderboards',
  templateUrl: './leaderboards.component.html',
  styleUrls: ['./leaderboards.component.css']
})
export class LeaderboardsComponent implements OnInit {
  @Input() leaderboards: Array<any>;
  @Input() language: any;
  portoLeaderBoards: Array<any> = [];
  tournamentsNameSpace: any;
  loadingLeaderBoards: boolean;

  constructor(private eventService: EventsService) {
    //tournament namespace
  }

  ngOnInit() {
    this.leaderboards.forEach((board, index) => {
      this.portoLeaderBoards[index] = {code: board.code, tournament_name: board.name, groups: {data: []}};
      if (index == 0) {
        this.loadingLeaderBoards = true;
        this.eventService.getTree(board.code, 1).subscribe(res => {
          res['tournament_code'] = board.code;
          this.portoLeaderBoards[0] = res;
          this.loadingLeaderBoards = false;
          // this.portoLeaderBoards[index] = res;
        })

      }
    })
  }

  onTabClick(event) {
    this.loadingLeaderBoards = true;
    this.eventService.getTree(this.leaderboards[event.index].code, 1).subscribe(res => {
      res['tournament_code'] = this.leaderboards[event.index].code;
      this.portoLeaderBoards[event.index] = res;
      this.loadingLeaderBoards = false;
    })
    if (this.portoLeaderBoards[event.index]) {
      this.tournamentsNameSpace.on(this.portoLeaderBoards[event.index].tournament_code, (msg) => {
        msg.tournamentTree.scores.forEach((score, index) => {
          this.portoLeaderBoards[event.index].groups.data[0].participants.data.forEach((participant, participant_index) => {
            if (participant.participant_id == score.participant_id) {
              if (score.game_rank)
                participant.game_ranks[0] = score.game_rank;
              if (score.kills)
                participant.kills[0] = score.kills;
              if (score.damage_rate)
                participant.damage_rate[0] = score.damage_rate;
              participant.score = score.score;
            }
          })
        })
      })
    }
  }

}
